// plugins/meta.js
export default defineNuxtPlugin(() => {
    const route = useRoute();
  
    watchEffect(() => {
      const provinceId = route.query.provinceId;
      const districtId = Array.isArray(route.query.districtId)
        ? route.query.districtId[0]
        : route.query.districtId;
  
      // Varsayılan meta bilgiler
      let title =
        "Hisseli Tapu Satışı - Hisse Oranı Seç ve Her Ay Kira Geliri Kazan";
      let description =
        "Hisseli tapu satışımız ile küçük bir yatırımla büyük bir adım atın. Hisse oranınızı seçin ve her ay kira geliri kazanmaya başlayın!";
  
      if (provinceId === "34") {
        if (!districtId) {
          // İstanbul genel meta bilgileri
          title =
            "İstanbul Hisseli Daire İlanları ve Hisseli Ev Fiyatları | Divissa";
          description =
            "İstanbul hisseli daire ilanları ve hisseli ev fiyatları Divissa'da! %10, %20, %30 ve daha fazla hisse seçenekleri ile İstanbul hisseli konut yatırımına başla.";
        } else {
            interface DistrictMeta {
                title: string;
                description: string;
              }
          const districtMeta :Record<string, DistrictMeta> = {
            "437": {
              title:
                "Çekmeköy Hisseli Daire İlanları ve Hisseli Ev Fiyatları | Divissa",
              description:
                "Çekmeköy hisseli daire ilanları ve hisseli ev fiyatları Divissa'da! %10, %20, %30 ve daha fazla hisse seçenekleri ile Çekmeköy hisseli konut yatırımına başla.",
            },
            "426": {
              title:
                "Bağcılar Hisseli Daire İlanları ve Hisseli Ev Fiyatları | Divissa",
              description:
                "Bağcılar hisseli daire ilanları ve hisseli ev fiyatları Divissa'da! %10, %20, %30 ve daha fazla hisse seçenekleri ile Bağcılar hisseli konut yatırımına başla.",
            },
            "423": {
              title:
                "Arnavutköy Hisseli Daire İlanları ve Hisseli Ev Fiyatları | Divissa",
              description:
                "Arnavutköy hisseli daire ilanları ve hisseli ev fiyatları Divissa'da! %10, %20, %30 ve daha fazla hisse seçenekleri ile Arnavutköy hisseli konut yatırımına başla.",
            },
            "427": {
              title:
                "Bahçelievler Hisseli Daire İlanları ve Hisseli Ev Fiyatları | Divissa",
              description:
                "Bahçelievler hisseli daire ilanları ve hisseli ev fiyatları Divissa'da! %10, %20, %30 ve daha fazla hisse seçenekleri ile Bahçelievler hisseli konut yatırımına başla.",
            },
          };
  
          if (districtId && districtMeta[districtId]) {
            title = districtMeta[districtId].title;
            description = districtMeta[districtId].description;
          }
        }
      }
  
      // Route path içinde "yatirimlar" varsa, meta bilgileri buna göre güncelle
      if (route.path.includes("yatirimlar") && !route.params.slugTitle ) {
        title = `Yatırımlar - ${title}`;
        description = `${description} Yatırımlar hakkında daha detaylı bilgi edinin.`;
        useHead({
          title,
          meta: [
              { name: 'title', content: title },
              { name: 'description', content: description },
              { property: "og:title", content: title },
              { property: "og:description", content: description },
              { property: "og:image", content: 'http://api.devissa.com/File/Image/Product_2647238da5784b139b0859ab47e9164f3e06a2c5506c4fb2ad73d62ea3d2cae8.webp' },
              { property: "og:image:width", content: '1200' },
              { property: "og:image:height", content: '630' },
              { property: "twitter:title", content: title },
              { property: "twitter:description", content: description },
              { property: "twitter:image", content: 'http://api.devissa.com/File/Image/Product_2647238da5784b139b0859ab47e9164f3e06a2c5506c4fb2ad73d62ea3d2cae8.webp' },
              { property: "twitter:card", content: 'summary_large_image' },
              // @ts-ignore
              { itemprop: "name", content: title },
              // @ts-ignore
              { itemprop: "description", content: description },
              // @ts-ignore
              { itemprop: "image", content: 'http://api.devissa.com/File/Image/Product_2647238da5784b139b0859ab47e9164f3e06a2c5506c4fb2ad73d62ea3d2cae8.webp' }
            ],
            link: [
              {
                rel: 'image_src',
                href: 'http://api.devissa.com/File/Image/Product_2647238da5784b139b0859ab47e9164f3e06a2c5506c4fb2ad73d62ea3d2cae8.webp'
              }
            ]
        });
      }
  
    
    });
  });
  